import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import RequestDemo from "./pages/RequestDemo";
import { Toaster } from "react-hot-toast";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RequestDemo />,
  },
]);

function App() {
  return (
    <>
      <Toaster />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
